var map = {
	"./announcement/Reducer": 7705,
	"./auth/Reducer": 12748,
	"./common/Reducer": 46447,
	"./course/Reducer": 69091,
	"./document/Reducer": 59507,
	"./forum/Reducer": 82807,
	"./guest/Reducer": 75462,
	"./home/Reducer": 80357,
	"./message/Reducer": 26481,
	"./newsLetter/Reducer": 64101,
	"./notification/Reducer": 92297,
	"./profile/Reducer": 39011,
	"./promoCode/Reducer": 43132,
	"./questions/Reducer": 14631,
	"./quizes/Reducer": 40091,
	"./reports/Reducer": 26753,
	"./review/Reducer": 46018,
	"./students/Reducer": 1006,
	"./users/Reducer": 37682,
	"./video/Reducer": 33889,
	"./webinar/Reducer": 21480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29364;